const calculateProbableFlow = (totalFlow) => {
  let probableFlow = 0;

  if (totalFlow < 18) {
    probableFlow = totalFlow;
  } else if (totalFlow < 24) {
    probableFlow = 18;
  } else if (totalFlow < 30) {
    probableFlow = 21.6;
  } else if (totalFlow < 36) {
    probableFlow = 22.8;
  } else if (totalFlow < 42) {
    probableFlow = 24;
  } else if (totalFlow < 48) {
    probableFlow = 24.6;
  } else if (totalFlow < 54) {
    probableFlow = 25.8;
  } else if (totalFlow < 60) {
    probableFlow = 26.4;
  } else if (totalFlow < 66) {
    probableFlow = 27;
  } else if (totalFlow < 72) {
    probableFlow = 27.6;
  } else if (totalFlow < 78) {
    probableFlow = 28.2;
  } else if (totalFlow < 84) {
    probableFlow = 28.8;
  } else if (totalFlow < 90) {
    probableFlow = 29.4;
  } else if (totalFlow < 96) {
    probableFlow = 30;
  } else if (totalFlow < 102) {
    probableFlow = 30.6;
  } else if (totalFlow < 108) {
    probableFlow = 31.2;
  } else if (totalFlow < 114) {
    probableFlow = 31.8;
  } else if (totalFlow < 120) {
    probableFlow = 32.4;
  } else if (totalFlow < 132) {
    probableFlow = 33;
  } else if (totalFlow < 144) {
    probableFlow = 33.6;
  } else if (totalFlow < 156) {
    probableFlow = 34.8;
  } else if (totalFlow < 168) {
    probableFlow = 35.4;
  } else if (totalFlow < 180) {
    probableFlow = 36.6;
  } else if (totalFlow < 192) {
    probableFlow = 37.2;
  } else if (totalFlow < 204) {
    probableFlow = 37.8;
  } else if (totalFlow < 216) {
    probableFlow = 39;
  } else if (totalFlow < 228) {
    probableFlow = 39.6;
  } else if (totalFlow < 240) {
    probableFlow = 40.2;
  } else if (totalFlow < 252) {
    probableFlow = 40.8;
  } else if (totalFlow < 264) {
    probableFlow = 41.4;
  } else if (totalFlow < 276) {
    probableFlow = 42.6;
  } else if (totalFlow < 288) {
    probableFlow = 43.2;
  } else if (totalFlow < 300) {
    probableFlow = 43.8;
  } else if (totalFlow < 330) {
    probableFlow = 44.4;
  } else if (totalFlow < 360) {
    probableFlow = 46.2;
  } else if (totalFlow < 390) {
    probableFlow = 47.4;
  } else if (totalFlow < 420) {
    probableFlow = 49.2;
  } else if (totalFlow < 450) {
    probableFlow = 50.4;
  } else if (totalFlow < 480) {
    probableFlow = 51.6;
  } else if (totalFlow < 510) {
    probableFlow = 53.4;
  } else if (totalFlow < 540) {
    probableFlow = 54.6;
  } else if (totalFlow < 570) {
    probableFlow = 55.8;
  } else if (totalFlow < 600) {
    probableFlow = 57;
  } else if (totalFlow < 630) {
    probableFlow = 58.2;
  } else if (totalFlow < 660) {
    probableFlow = 60;
  } else if (totalFlow < 690) {
    probableFlow = 61.2;
  } else if (totalFlow < 720) {
    probableFlow = 62.4;
  } else if (totalFlow < 750) {
    probableFlow = 63.6;
  } else if (totalFlow < 780) {
    probableFlow = 64.8;
  } else if (totalFlow < 810) {
    probableFlow = 66;
  } else if (totalFlow < 840) {
    probableFlow = 66.6;
  } else if (totalFlow < 870) {
    probableFlow = 67.8;
  } else if (totalFlow < 900) {
    probableFlow = 69;
  } else if (totalFlow < 930) {
    probableFlow = 70.2;
  } else if (totalFlow < 960) {
    probableFlow = 71.4;
  } else if (totalFlow < 990) {
    probableFlow = 72.6;
  } else if (totalFlow < 1020) {
    probableFlow = 73.8;
  } else if (totalFlow < 1050) {
    probableFlow = 74.4;
  } else if (totalFlow < 1080) {
    probableFlow = 75.6;
  } else if (totalFlow < 1110) {
    probableFlow = 76.8;
  } else if (totalFlow < 1140) {
    probableFlow = 78;
  } else if (totalFlow < 1170) {
    probableFlow = 78.6;
  } else if (totalFlow < 1200) {
    probableFlow = 79.8;
  } else if (totalFlow < 1260) {
    probableFlow = 81;
  } else if (totalFlow < 1320) {
    probableFlow = 82.8;
  } else if (totalFlow < 1380) {
    probableFlow = 85.2;
  } else if (totalFlow < 1440) {
    probableFlow = 87;
  } else if (totalFlow < 1500) {
    probableFlow = 88.8;
  } else if (totalFlow < 1560) {
    probableFlow = 90.6;
  } else {
    probableFlow = 93;
  }

  return probableFlow;
};

export default calculateProbableFlow;